import type { ComponentType } from 'react';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import ThemeProvider from '@rover/react-lib/components/utils/ThemeProvider';
import { I18nProvider } from '@rover/react-lib/utils/i18n';
import { i18nConfig } from '@rover/utilities/translation';

import 'react-hot-loader/patch';

export default function renderRootElement<Props>(
  Component: ComponentType<Props>,
  elementSelector: string,
  props?: Props
): void {
  const rootElement = document.querySelector(elementSelector);
  const container = (
    <AppContainer>
      <I18nProvider {...i18nConfig}>
        <ThemeProvider>
          {/* @ts-expect-error */}
          <Component {...props} />
        </ThemeProvider>
      </I18nProvider>
    </AppContainer>
  );

  if (!rootElement) {
    throw new Error('rootElement not found.');
  }

  ReactDOM.render(container, rootElement);
}



// WEBPACK FOOTER //
// ../react-lib/src/utils/renderRootElement.tsx